import { createTheme } from '@mui/material/styles';
import { COLORS } from 'utils/GlobalVariables';
import { generalTheme } from './general_theme';

// Création du thème personnalisé
export const tabsTheme = createTheme(generalTheme, {
  components: {
    // Personnalisation du composant Tabs
    MuiTabs: {
      styleOverrides: {
        root: {
          // Styles pour le conteneur des tabs si besoin
        },
        indicator: {
          //   backgroundColor: generalTheme.palette.primary.main, // Couleur de l'indicateur de sélection
        },
      },
    },
    // Personnalisation du composant Tab
    MuiTab: {
      styleOverrides: {
        root: {
          color: generalTheme.palette.secondary.main,
          '&:hover': {
            color: generalTheme.palette.primary.main,
            opacity: 1,
          },
        },
      },
    },
  },
});

export const invertedButtonTheme = createTheme(generalTheme, {
  palette: {
    primary: generalTheme.palette.secondary,
    secondary: generalTheme.palette.primary,
  },
});

export const generalSelectTheme = createTheme(generalTheme, {
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '0px',
          '&:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': {
            borderColor: generalTheme.palette.secondary.main,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: generalTheme.palette.primary.main,
          },
        },
        notchedOutline: {
          borderColor: generalTheme.palette.primary.main,
          borderWidth: '1px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.6)',
          '&.MuiInputLabel-shrink': {
            color: generalTheme.palette.secondary.main,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: generalTheme.palette.secondary.main,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: generalTheme.palette.primary.main,
          '&.Mui-checked': {
            color: generalTheme.palette.secondary.main,
          },
        },
      },
    },
  },
});
